import type { FC } from 'react'
import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Navigation from '@segment/templates/Navigation'
import Footer from '@segment/templates/Footer/Footer'
import LogoCarousel from '@segment/templates/LogoCarousel'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import ManageQualityData from './components/ManageQualityData'
import DataCollection from './components/DataCollection'
import DataPrivacy from './components/DataPrivacy'
import DataActivation from './components/DataActivation'
import WhySegment from './components/WhySegment'
import Resources from './components/Resources'
import GettingStarted from './components/GettingStarted'
import TestimonialsSlider from './components/TestimonialsSlider'

const copy = {
  pageTitle: `Customer Data Management & Integration | Twilio Segment`,
  pageDescription: `Twilio Segment’s customer data platform makes it easy to optimize real-time data collection, compliance, and activation with a flexible platform that offers seamless integrations with your data warehouse and tech stack while also ensuring data quality.`,
}

const CustomerDataManagementIntegrationView: FC = () => {
  const theme = useTheme()

  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle={copy.pageTitle}
        pageDescription={copy.pageDescription}
        bodyBackground={theme.palette.neutrals.white[100]}
        themeColor={theme.palette.neutrals.white[100]}
      >
        <Navigation />
        <AppearanceProvider appearance="twilioDark">
          <Hero />
        </AppearanceProvider>
        <Main>
          <LogoCarouselWrapper>
            <LogoCarousel />
          </LogoCarouselWrapper>
          <ManageQualityData />
          <DataCollection />
          <DataPrivacy />
          <DataActivation />
          <WhySegment />
          <TestimonialsSlider />
          <Resources />
          <GettingStarted />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

export default CustomerDataManagementIntegrationView

const Main = styled.main``

const LogoCarouselWrapper = styled.div`
  padding: 80px 0;

  ${({ theme }) => theme.breakpoints.down(`md`)} {
    padding: 40px 0;
  }
`
